module.exports = "<div class=\"custom-number-updown\">\r\n    <button class=\"cnud-circle-btn\" (click)=\"decreaseValue()\">−</button>\r\n  \r\n    <span class=\"cnud-value\">{{ value }}{{ suffix }}</span>\r\n  \r\n    <button class=\"cnud-circle-btn\" (click)=\"increaseValue()\">+</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/custom-number-updown/custom-number-updown.component.html
// module id = ./src/app/components/custom-number-updown/custom-number-updown.component.html
// module chunks = main